<div class="modal-header bg-light">
  <h4 class="modal-title">Reporte de aerovales - {{aerovales[0]?.nombreCliente}} - {{aerovales[0]?.cuit}}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close(false)"></button>
</div>
<div class="modal-body">
  <nav class="navbar navbar-light bg-light navbar-expand-lg">
    <form class="form-inline flex-fill">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <ul class="navbar-nav d-flex justify-content-between w-100">
        <li class="nav-item">
          <p class="nav-link mb-0"><small>Los valores de monto e impuestos son estimados al momento de realizar el despacho</small></p>
        </li>
        <li class="nav-item">
          <button (click)="descargarExcel()" class="btn btn-outline-success">Descargar</button>
        </li>
      </ul>
    </form>
  </nav>

  <div class="col container table-container">
    <table class="table table-striped table-responsive">
      <thead>
        <th scope="col">
          <p class="text-center text-primary">
            Aeroplanta
          </p>
        </th>

        <th scope="col">
          <p class="text-center text-primary">
            Aerovale
          </p>
        </th>

        <th scope="col">
          <p class="text-center text-primary">
            Matr&iacute;cula
          </p>
        </th>

        <th scope="col">
          <p class="text-center text-primary">
            C&oacute;digo Prod.
          </p>
        </th>

        <th scope="col">
          <p class="text-center text-primary">
            Nombre Prod.
          </p>
        </th>

        <th scope="col">
          <p class="text-center text-primary ">
            Unidad de medida
          </p>
        </th>

        <th scope="col">
          <p class="text-center text-primary">
            Cantidad
          </p>
        </th>

        <th scope="col">
          <p class="text-center text-primary">
            Operaci&oacute;n
          </p>
        </th>
        <th scope="col">
          <p class="text-center text-primary">
            Rancho
          </p>
        </th>
        <th scope="col">
          <p class="text-center text-primary">
            Monto estimado
          </p>
        </th>
        <th scope="col">
          <p class="text-center text-primary">
            Moneda
          </p>
        </th>
        <th scope="col">
          <p class="text-center text-primary">
            Cotizaci&oacute;n
          </p>
        </th>
        <th scope="col">
          <p class="text-center text-primary">
            Imp. Estimados
          </p>
        </th>
      </thead>

      <tbody>
        @for (producto of aerovales; track producto.prefijo ){
          <tr>
          <td class="text-center">{{producto.aeroplanta}}</td>
          <td class="text-center">{{producto.prefijo | aerovalePrefijo}}{{producto.numeroAerovale | aerovaleNumero}}</td>
          <td class="text-center">{{producto.matricula}}</td>
          <td class="text-center">{{producto.codigoProducto}}</td>
          <td class="text-center">{{producto.nombreProducto}}</td>
          <td class="text-center">{{unidadMedida[producto.unidadMedida]}}</td>
          <td class="text-center">{{producto.volumenNaturales | number: '1.0-0'}}</td>
          <td class="text-center">{{tipoVuelo[producto.tipoVuelo]}}</td>
          <td class="text-center">{{producto.rancho ?? '-'}}</td>
          <td class="text-center">{{producto.monto | number:'1.2-2'}}</td>
          <td class="text-center">{{obtenerDescripcionMoneda(producto.tipoMoneda)}}</td>
          <td class="text-center">{{producto.cotizacion | number:'1.2-2'}}</td>
          <td class="text-center">{{producto.impuestos | number:'1.2-2'}}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
